import { defineStore } from "pinia";
import * as duracionContratoApi from "@/services/duracionesContrato.js";

import { comboTiposDeCuota } from "@/enums/TipoCuota";

export const useModificadorPrecioModuloStore = defineStore("ModificadorPrecioModuloStore", {
  state() {
    return {
      // La duración de contrato que se está editando
      duracionContrato: {},
      // Las tasas de conversión de la divisa
      modificadores: [],
    };
  },
  getters: {
    comboTiposDeCuota() {
      return comboTiposDeCuota;
    },
  },
  actions: {
    async cargar(id) {
      this.duracionContrato = await duracionContratoApi.cargar(id);
    },
    async cargarModificadores(id) {
      this.modificadores = await duracionContratoApi.cargarModificadores(id);
    },
    async guardarModificador(modificador) {
      modificador.duracionContratoId = this.duracionContrato.id;
      await duracionContratoApi.guardarModificador(modificador);
      await this.cargarModificadores(this.duracionContrato.id);
    },
    async eliminarModificador(id) {
      await duracionContratoApi.eliminarModificador(id);
      await this.cargarModificadores(this.duracionContrato.id);
    },
  },
});
